import { Exception } from '../Exception';

export default class AuthInvalidGrantException extends Exception {
  constructor(originalException: unknown) {
    const message = `OAuth invalid_grant: refresh token is probably expired`;
    super(message, originalException);
  }
}
